module.exports = __webpack_public_path__ + "static/tpp-creator03-42d33f70669a59602810a54d27e7b51a.jpg";